"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var utilities_1 = require("../../../editor/widgets/EnetpulseWidget/utilities");
var utilities_2 = require("../../../editor/widgets/EnetpulseWidget/utilities");
var utilities_3 = require("../../../utilities/utilities");
var MessageBlock_1 = tslib_1.__importDefault(require("../../components/MessageBlock"));
var EnetpulseWidget = function (_a) {
    var data = _a.data, renderEmpty = _a.renderEmpty;
    var widgetType = data.widgetType, widgetBaseUrl = data.widgetBaseUrl, widgetOptions = data.widgetOptions, widgetDeepLinks = data.widgetDeepLinks, elementId = data.elementId;
    var _b = React.useState(false), isInsideEditor = _b[0], setIsInsideEditor = _b[1];
    React.useEffect(function () {
        if (!widgetBaseUrl || !elementId) {
            return;
        }
        var inEditor = !!document.querySelector(".ql-editor");
        setIsInsideEditor(inEditor);
        // ak sme vnutri pages editora, alebo na SSR nerenderujeme
        // potrebne javascripty
        if (inEditor || !utilities_3.isBrowser()) {
            return;
        }
        var domelementId = "#" + elementId;
        var mainScriptId = "#enetpulse-mainscript-" + elementId;
        var timeoutID = window.setTimeout(function () {
            if (!document.querySelector(mainScriptId)) {
                utilities_3.scribe(domelementId, utilities_2.getSourceCode(elementId, widgetBaseUrl, widgetOptions, widgetDeepLinks), 'replace');
            }
        }, 0);
        return function () {
            window.clearTimeout(timeoutID);
        };
    }, [widgetBaseUrl, widgetOptions, widgetDeepLinks, setIsInsideEditor]);
    if ((!widgetType || !widgetBaseUrl || !elementId) && renderEmpty) {
        return React.createElement(React.Fragment, null, renderEmpty('enetpulseWidget'));
    }
    return (React.createElement(React.Fragment, null, isInsideEditor ? (React.createElement(MessageBlock_1["default"], { color: "primary" },
        utilities_3.__('ZOH Fleshscore'),
        " - ",
        utilities_1.getWidgetTypeLabel(widgetType || ''))) : (React.createElement("div", { id: elementId }))));
};
exports["default"] = React.memo(EnetpulseWidget);
